var map = {
	"./bankong.png": "ee4c",
	"./baobian.png": "3efd",
	"./beveledge.png": "a92f",
	"./bheight.png": "1b8b",
	"./blayer.png": "b566",
	"./blind.png": "dea3",
	"./charcolor.png": "b7c5",
	"./color.png": "5122",
	"./copper.png": "dd07",
	"./cover_1.png": "8088",
	"./cover_2.png": "9d62",
	"./cover_3.png": "f9c8",
	"./cover_4.png": "4993",
	"./cross_board.png": "6fea",
	"./insidecopper.png": "065a",
	"./label_remark.png": "cf90",
	"./length.png": "e25c",
	"./lineweight.png": "4a14",
	"./spray_1.png": "b3e0",
	"./spray_2.png": "ec32",
	"./spray_3.png": "6929",
	"./via_in_pad.png": "cb65",
	"./vias.png": "7839"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0522";